import CommunityProfilePage from './CommunityProfilePage'

export default CommunityProfilePage
export * from './CommunityProfilePage'
